import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const vendor: AnswerPathTreeNode = { path: 'vendor', children: [{ path: 'code', nodeId: NodeIds.vendorCode }] };
